<template>
<div data-v-46e20943="" data-v-2ac6a5fc="" class="news-details-page">
    <div data-v-46e20943="" class="news-details-container">
        <!-- 加载状态 -->
        <div v-if="isLoading" class="loading-state">
            <div class="loading-icon"></div>
            <p>加载中...</p>
        </div>
        
        <!-- 错误状态 -->
        <div v-if="loadError" class="error-state">
            <p>数据加载失败</p>
            <button @click="getInfo()" class="retry-btn">重试</button>
        </div>
        
        <!-- 内容区域 -->
        <div v-if="!isLoading && !loadError && Object.keys(info).length">
            <div data-v-46e20943="" class="news-title-wrapper">
                <p data-v-46e20943="" class="title">{{info.title}}</p>
                <p data-v-46e20943="" class="time">{{info.created_at}}</p>
                <!-- 类型标签 -->
                <p class="news-type" :class="getTypeClass(info.type)">
                    {{ getTypeName(info.type) }}
                </p>
            </div>
            
            <!-- 内容区域 - 图片自适应处理 -->
            <div data-v-46e20943="" class="news-content" v-html="processContentImages(info.content)"></div>
        </div>
        
        <!-- 空状态 -->
        <div v-if="!isLoading && !loadError && !Object.keys(info).length" class="empty-state">
            <p>未找到相关新闻</p>
            <button @click="$router.back()" class="back-btn">返回列表</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'myNewsInfo',
  data() {
    return { 
      info: {}, 
      id: null,
      isLoading: false,
      loadError: false
    };
  },
  created() {
    // 从路由获取ID
    const query = this.$route.query;
    if (query && query.id) {
      this.id = query.id;
      this.getInfo();
    } else {
      this.loadError = true;
      console.error('未找到新闻ID');
    }
  },
  methods: {
    // 加载新闻详情
    getInfo() {
      // 重置状态
      this.isLoading = true;
      this.loadError = false;
      this.info = {};
      this.$parent.showLoading();

      this.$apiFun
        .post('/api/noticeList', { page: 1, limit: 999 })
        .then(res => {
          this.isLoading = false;
          this.$parent.hideLoading();
          
          console.log('接口返回数据:', res);
          
          // 检查接口返回是否正常
          if (!res) {
            this.handleError('接口返回为空');
            return;
          }
          
          // 不同接口可能有不同的成功状态码
          if (res.code !== 200 && res.code !== 0) {
            this.handleError(res.message || '获取数据失败');
            return;
          }
          
          // 检查数据结构
          if (!res.data || !Array.isArray(res.data.data)) {
            this.handleError('数据格式不正确');
            return;
          }
          
          // 从列表中查找当前ID对应的数据
          const noticeList = res.data.data;
          const foundItem = noticeList.find(el => el.id == this.id);
          
          if (foundItem) {
            this.info = foundItem;
          } else {
            this.handleError('未找到对应新闻');
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.loadError = true;
          this.$parent.hideLoading();
          console.error('请求失败:', error);
          this.$parent.showTost(0, '网络错误，请稍后重试');
        });
    },
    
    // 错误处理
    handleError(message) {
      this.loadError = true;
      this.$parent.showTost(0, message);
      console.error(message);
    },
    
    // 增强的图片自适应处理
    processContentImages(content) {
      if (!content) return '';
      
      // 更强大的图片处理正则，确保所有图片都能被处理
      // 移除原有的宽度、高度属性，添加自适应类和样式
      return content
        // 移除所有图片的width和height属性
        .replace(/<img([^>]+)width="[^"]*"/gi, '<img$1')
        .replace(/<img([^>]+)height="[^"]*"/gi, '<img$1')
        .replace(/<img([^>]+)width='[^']*'/gi, '<img$1')
        .replace(/<img([^>]+)height='[^']*'/gi, '<img$1')
        // 添加自适应类和必要属性
        .replace(/<img/gi, '<img class="content-image" loading="lazy" style="max-width:100%;height:auto;"');
    },
    
    // 获取类型名称
    getTypeName(type) {
      const typeStr = String(type);
      switch(typeStr) {
        case '1': return '通知';
        case '2': return '活动';
        case '3': return '公告';
        default: return '消息';
      }
    },
    
    // 获取类型样式类
    getTypeClass(type) {
      const typeStr = String(type);
      switch(typeStr) {
        case '1': return 'type-notice';
        case '2': return 'type-activity';
        case '3': return 'type-announcement';
        default: return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news-details-page {
  background-color: #ffffff; /* 白色背景 */
  min-height: 100vh;
  padding: 20px 0;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.news-details-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box; /* 确保padding不会增加总宽度 */
}

.news-title-wrapper {
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 25px;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 15px 0;
  line-height: 1.4;
}

.time {
  font-size: 14px;
  color: #999999;
  margin: 0 0 10px 0;
}

.news-type {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  color: white;
  font-weight: 500;
  margin: 0;
  
  &.type-notice {
    background-color: #409eff;
  }
  
  &.type-activity {
    background-color: #67c23a;
  }
  
  &.type-announcement {
    background-color: #e6a23c;
  }
}

.news-content {
  color: #333333;
  font-size: 16px;
  line-height: 1.8;
  overflow: hidden; /* 防止图片溢出容器 */
  
  /* 确保段落间距舒适 */
  p {
    margin: 0 0 1.5em 0;
  }
  
  /* 列表样式优化 */
  ul, ol {
    margin: 0 0 1.5em 0;
    padding-left: 2em;
  }
  
  /* 图片自适应核心样式 - 优先级最高 */
  .content-image {
    max-width: 100% !important; /* 强制不超过容器宽度 */
    height: auto !important; /* 保持宽高比 */
    display: block !important; /* 块级元素，确保margin生效 */
    margin: 20px auto !important; /* 居中显示，添加上下边距 */
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    object-fit: contain; /* 确保图片完整显示，不裁剪 */
    padding: 0 !important; /* 移除可能的内边距 */
    border: none !important; /* 移除可能的边框 */
  }
  
  /* 处理可能包含图片的容器 */
  figure, .img-container {
    max-width: 100% !important;
    margin: 20px auto !important;
    padding: 0 !important;
  }
  
  /* 链接样式 */
  a {
    color: #409eff;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

/* 加载状态样式 */
.loading-state {
  text-align: center;
  padding: 80px 20px;
  color: #666;
  font-size: 16px;
}

.loading-icon {
  width: 40px;
  height: 40px;
  margin: 0 auto 15px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 错误状态样式 */
.error-state {
  text-align: center;
  padding: 80px 20px;
  color: #666;
  font-size: 16px;
}

/* 空状态样式 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #666;
  font-size: 16px;
}

/* 按钮样式 */
.retry-btn, .back-btn {
  margin-top: 15px;
  padding: 8px 16px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #308eff;
  }
}

/* 响应式调整 - 针对不同屏幕尺寸优化图片显示 */
@media (max-width: 768px) {
  .title {
    font-size: 20px;
  }
  
  .news-content {
    font-size: 15px;
    line-height: 1.7;
  }
  
  .news-details-container {
    padding: 0 15px;
  }
  
  .content-image {
    margin: 15px auto !important; /* 小屏幕减少边距 */
    border-radius: 4px !important;
  }
}

@media (max-width: 480px) {
  .news-content {
    font-size: 14px;
  }
  
  .content-image {
    margin: 10px auto !important; /* 超小屏幕进一步减少边距 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/myNewsInfo.vue